import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import tw from "twin.macro"
//import { Icon } from "../Icon/Icon"
import { withAnnouncement } from "./withAnnouncement"
import { BackgroundContainer, StyledContainer } from "../Styled/Container"

//const CloseIcon = tw(Icon)`px-0-2 md:px-1`
const IconImage = tw.img`max-h-2`
const AnnouncementBar = styled(BackgroundContainer)`
  ${tw`flex justify-center items-center`}
`
const Container = styled(StyledContainer)`
  ${tw`relative flex-col flex items-center justify-center pt-1 pr-1 pl-1 md:pb-1 md:flex-row md:flex-row max-w-xl min-h-full w-80-vw`}
`
const Desktop = tw.div`hidden md:block`
const Mobile = tw.div`block md:hidden`
const ItemWrap = tw.div`flex items-center`
const Item = tw.div`flex mb-1 items-center justify-center`
const Text = tw.div`text-center text-lightest uppercase px-1` // font
const Marquee = tw.span`text-center text-lightest uppercase px-1`
const ScrollText = tw.div``
// const Text = tw.p`md:text-14 text-10 leading-1.12 font-display text-lightest uppercase px-1`  // font change

//const Button = tw.button`text-16 font-display text-lightest`
//const Div = tw.div`flex justify-center w-full`
//const ButtonDiv = tw.div`relative -right-3`

export const Announcement = withAnnouncement(
  ({ items, textColor, barBGcolor }): JSX.Element => {
    return (
      <AnnouncementBar style={{ background: barBGcolor.hex }}>
        <Desktop>
          <Container>
            {items?.map(({ icon, link, title }, index) => (
              <ItemWrap key={index}>
                {icon?.asset?.url ? <IconImage alt="Shipping" src={icon?.asset?.url} /> : null}
                <Text className="body_small_highlight" style={{ color: textColor.hex }}>
                  {link?.link ? <Link to={link?.link}>{title}</Link> : title}
                </Text>
              </ItemWrap>
            ))}
          </Container>
        </Desktop>
        <Mobile>
          {items.length && items[0].mobiletitle ? (
            <Container>
              {items?.map(({ mobileicon, mobilelink, mobiletitle }, index) => (
                <ItemWrap key={index}>
                  {mobiletitle ? (
                    <Item>
                      {mobileicon?.asset?.url ? <IconImage alt="Shipping" src={mobileicon?.asset?.url} /> : null}
                      <ScrollText className="animate-marquee whitespace-nowrap">
                        <Marquee className="body_small_highlight" style={{ color: textColor.hex }}>
                          &nbsp; {mobilelink?.link ? <Link to={mobilelink?.link}>{mobiletitle}</Link> : mobiletitle}
                        </Marquee>
                      </ScrollText>
                    </Item>
                  ) : null}
                </ItemWrap>
              ))}
            </Container>
          ) : null}
        </Mobile>
      </AnnouncementBar>
    )
  }
)

{
  /* <ButtonDiv>  
  <Desktop>
  <Button onClick={() => handleHide()}><CloseIcon name={`close`} size={40} /></Button>
  </Desktop>
  <Mobile>
  <Button onClick={() => handleHide()}><CloseIcon name={`close`} size={18} /></Button>
  </Mobile>
  </ButtonDiv>
  */
}
